import { BuyerOptionProps } from '.';

import GenericText from './GenericText';


export default function LargeParagraph(props: BuyerOptionProps) {
  /**
   * JR 22.05.25: https://jira.atlassian.com/browse/JRACLOUD-63007 reports the jira.text.field.character.limit as 32767 in JIRA Cloud so we 
   * will set that max length for the Large Paragraph component. 
   */
  return <GenericText textFieldMaxLength={32767} multiline={true} preserveRawText={true} {...props} />;
}
